import React from "react";
import { Row, Col } from "antd";
import * as actions from "../../../Estore/_redux/Estore/basicSettingsAction";
import SectionOne from "./SectionOne";
import BasicStats from "./BasicStats";
// import { shallowEqual,  useSelector } from "react-redux";
import { setCurrency } from "../../../Common/utils";
import { useState } from "react";
import { DashboardBalanceVisibilityProvider } from "./balanceVisibility";

export const Dashboard = () => {
  const [dashboardFilters, setDashboardFilters] = useState({ channel_ids: [], start_date: "", end_date: "" });
    let [searchChannelsEntities, setSearchChannelsEntities] = useState([]);

  return (
    <DashboardBalanceVisibilityProvider>
      <div style={{width: "100%"}}>
        <Row gutter={[0, 25]}>
          <Col span={24}>
            <SectionOne dashboardFilters={dashboardFilters} setDashboardFilters={setDashboardFilters} searchChannelsEntities={searchChannelsEntities} setSearchChannelsEntities={setSearchChannelsEntities} />
          </Col>
        </Row>
      </div>
    </DashboardBalanceVisibilityProvider>
  );
};
